import CheckBox from '~/js/components/CheckBox';
import popovers from '~/js/modules/popovers';

const internals = {
    roomView: {},
    roomFeatures: {},
    roomSpecialOffers: {},
};

const roomView = [
    {
        label: 'Beachfront',
    },
    {
        label: 'Oceanfront',
    },
    {
        label: 'Oceanview',
    },
    {
        label: 'Partial Oceanview',
    },
    {
        label: 'Pool',
    },
    {
        label: 'Garden',
    },
];


class Filters extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            filters: {},
            status: 'loading',
            rooms: [],
        };
    }

    componentDidMount() {

       // this.mergePropsWithState();
    }


    // mergePropsWithState() {

    //      const { filters, status } = this.props;

    //     this.setState({ filters, status });
    // }

    // componentWillReceiveProps(prevState, currentState) {
    //     if
    // }

    static getDerivedStateFromProps(nextProps, prevState) {

        // if (nextProps.status !== this.state.status) {
        //     this.setState({ status });
        // }

        // if (nextProps.filters !== this.state.filters) {
        //     this.setState({ filters });
        // }

        // console.log('prevState', prevState);
        // console.log('this.props', nextProps);

         return {
           ...prevState,
           ...nextProps
        };
    }

    componentDidUpdate() {
        //  I need to find a better solution
        popovers();
    }

    render() {

        const { features = {}, views = {}  } = this.state.filters;
        const { status } = this.state;
        const { resetButtonVisibility } = this.props;

        return (
            <section className="rooms-filter js-rooms-filter">
                <div className="container">
                    <div className="rf-head">
                        <button className="btn rf-close js-rf-close">
                            <i className="ic ic-close"/>
                        </button>
                        <div className="row">
                            <div className="col-sm-6">
                                <span className="rf-lg-text">FILTER ROOMS BY</span> <span className={`rf-reset ${resetButtonVisibility}`} onClick={ this.props.resetFilters }>Reset <i className="ic ic-reset"/></span>
                            </div>
                            <div className="col-sm-6 hidden-xs text-right">
                                <a href="#levels" className="rf-hover js-magnific-popup">About Rooms &amp; Suites Levels
                                <i className="ic ic-info"/></a>
                            </div>
                        </div>
                    </div>
                    <div className="rf-content">
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="rf-pane">
                                    <h4 className="rf-title">ROOM VIEW</h4>
                                    <ul className="rf-list js-scroll-list">
                                        {
                                            Object.keys(views).map(label => {
                                                return (
                                                    <li key={label} className="rf-list-item">
                                                        <CheckBox
                                                            id={label}
                                                            classNames="rf-checkbox"
                                                            name="views"
                                                            value={label}
                                                            onChange={this.props.handleChange}
                                                            label={label}
                                                            isChecked={ views[label].checked }
                                                            isDisabled={ views[label].disabled }
                                                            />
                                                    </li>
                                                );
                                            })
                                        }
                                        {
                                            status === 'loading' &&
                                            <div className="loading" />
                                        }
                                    </ul>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="rf-pane">
                                    <h4 className="rf-title">Room FEATURES</h4>
                                    <ul className="rf-list js-scroll-list">
                                        {
                                            Object.keys(features).map(label => {
                                                return (
                                                    <li key={label} className="rf-list-item">
                                                        <CheckBox
                                                            id={label}
                                                            classNames="rf-checkbox"
                                                            name="features"
                                                            value={label}
                                                            onChange={this.props.handleChange}
                                                            label={label}
                                                            isChecked={ features[label].checked }
                                                            isDisabled={ features[label].disabled }
                                                            />
                                                    </li>
                                                );
                                            })
                                        }
                                        {
                                            status === 'loading' &&
                                            <div className="loading" />
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="rf-foot">
                        <button className="btn rf-btn js-rf-close">VIEW ROOMS <span>({this.state.rooms.length})</span></button>
                    </div>
                </div>
            </section>
        );
    }
}

export default Filters;
